/* DigitalPower — „За нас“ (v1.7): dp-about-story (думи по скрол), dp-team (панели + плаваща снимка).
   Зарежда се от секциите с defer. Без библиотеки. Hero числата и particles са в dp.js ([data-count], [data-particles]),
   картите с наклон — в dp.js ([data-tilt-zone]). */
(function () {
  'use strict';
  if (window.__dpAbout) return;
  window.__dpAbout = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Текст, който се запалва дума по дума със скрола ---------- */
  var wordBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-dp-words]'));
  if (wordBlocks.length) {
    var items = wordBlocks.map(function (el) {
      return { el: el, words: Array.prototype.slice.call(el.querySelectorAll('.dp-ast__w')), on: -1 };
    });
    function paintWords() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        var start = vh * 0.82;                 /* the paragraph starts lighting up when its top crosses 82% of the viewport */
        var travel = r.height + vh * 0.3;       /* and is fully lit a bit before its bottom reaches the middle */
        var p = (start - r.top) / travel;
        p = Math.max(0, Math.min(1, p));
        var n = reduce ? it.words.length : Math.round(p * it.words.length);
        if (n === it.on) return;
        it.on = n;
        for (var i = 0; i < it.words.length; i++) it.words[i].classList.toggle('is-on', i < n);
      });
    }
    var wordTick = false;
    function onScrollWords() {
      if (wordTick) return;
      wordTick = true;
      requestAnimationFrame(function () { wordTick = false; paintWords(); });
    }
    window.addEventListener('scroll', onScrollWords, { passive: true });
    window.addEventListener('resize', onScrollWords);
    window.addEventListener('load', paintWords);
    paintWords();
  }

  /* ---------- 2. Екип: един отворен панел, клавиатура, aria ---------- */
  document.querySelectorAll('[data-dp-team]').forEach(function (section) {
    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-dp-member]'));
    function setOpen(row, open) {
      var btn = row.querySelector('[data-dp-member-toggle]');
      var panel = row.querySelector('.dp-team__panel');
      row.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
      }
    }
    section.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-dp-member-toggle]');
      if (!btn || !section.contains(btn)) return;
      var row = btn.closest('[data-dp-member]');
      var willOpen = !row.classList.contains('is-open');
      rows.forEach(function (r) { if (r !== row && r.classList.contains('is-open')) setOpen(r, false); });
      setOpen(row, willOpen);
      if (willOpen) {
        hideFloat();
        /* keep the name in view when a panel above it collapses */
        window.setTimeout(function () {
          var r = btn.getBoundingClientRect();
          if (r.top < 0) btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }, 80);
      }
    });

    /* ---------- 3. Плаваща снимка, която следва курсора над реда (само мишка) ---------- */
    var float = section.querySelector('[data-dp-team-float]');
    var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    var fx = 0, fy = 0, tx = 0, ty = 0, raf = 0, active = false, current = null;
    function hideFloat() {
      if (!float) return;
      active = false; current = null;
      float.classList.remove('is-on');
    }
    function showFor(row) {
      if (!float || row === current) return;
      current = row;
      var img = float.querySelector('img');
      var mono = float.querySelector('.dp-team__float-mono');
      var src = row.getAttribute('data-img');
      if (src) {
        img.src = src; img.hidden = false; mono.hidden = true;
      } else {
        img.hidden = true; mono.hidden = false;
        mono.textContent = row.getAttribute('data-ini') || '';
        mono.className = 'dp-team__float-mono dp-team__mono--' + (row.getAttribute('data-grad') || 'card');
      }
      float.classList.add('is-on');
    }
    function loop() {
      fx += (tx - fx) * 0.18;
      fy += (ty - fy) * 0.18;
      float.style.setProperty('--fx', fx.toFixed(1) + 'px');
      float.style.setProperty('--fy', fy.toFixed(1) + 'px');
      float.style.setProperty('--fr', ((tx - fx) * 0.08 - 4).toFixed(2) + 'deg');
      if (active || Math.abs(tx - fx) > 0.5 || Math.abs(ty - fy) > 0.5) raf = requestAnimationFrame(loop);
      else raf = 0;
    }
    if (float && canHover && !reduce) {
      section.addEventListener('pointermove', function (e) {
        var row = e.target.closest && e.target.closest('[data-dp-member]');
        if (!row || row.classList.contains('is-open') || !e.target.closest('[data-dp-member-toggle]')) { hideFloat(); return; }
        tx = e.clientX + 120; ty = e.clientY + 40;
        if (!active) { active = true; fx = tx; fy = ty; }
        showFor(row);
        if (!raf) raf = requestAnimationFrame(loop);
      });
      section.addEventListener('pointerleave', hideFloat);
      window.addEventListener('scroll', hideFloat, { passive: true });
    }
  });
})();
